var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status.value != 0)?_c('div',{staticClass:"progress-width",style:({
        background: ("" + (_vm.status.color)),
        width: ((_vm.status.value) + "%")
    })}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }